import router from "./router";
import store from "./store";

import { Message } from "element-ui";
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";

import { getAccessToken } from "@/utils/auth";

// NProgress.configure({ showSpinner: false });

const whiteList = ["/", "/details", "/login", "/details/list", "/exam_registration_site_test/"];
router.beforeEach((to, from, next) => {
  // NProgress.start();
  // 没有token
  if (whiteList.indexOf(to.path) !== -1) {
    // 在免登录白名单，直接进入
    next();
  } else {

    if (getAccessToken()) {
      store.commit(
        "SET_CURRENT_EXAM_ID",
        localStorage.getItem("currentExamId") || "",
      ); // 设置当前考试id
      store
        .dispatch("GetInfo")
        .then(() => {
          next();
        })
        .catch((err) => {
          store.dispatch("LogOut").then(() => {
            // Message.error(err);
            next({ path: "/login" });
          });
        });
    } else {
      const redirect = encodeURIComponent(to.fullPath); // 编码 URI，保证参数跳转回去后，可以继续带上
      next(`/login?redirect=${redirect}`); // 否则全部重定向到登录页
      // NProgress.done();
    }
  }
});

router.afterEach(() => {
  // NProgress.done();
});
